<template>
    <div class="home-bg" :class="{inited}" :style="{height: windowHeight}">
        <video class="video" :style="styles" autoplay loop preload="auto" muted>
            <source src="//growth-s3.s3.ap-southeast-1.amazonaws.com/home.m4v" type="video/mp4">
        </video>
        <div class="text" :style="styles">
            <div class="text1">Accelerating Business<br>Growth</div>
            <p class="text2"></p>
        </div>

        <div class="down" @click="nextPage">
            <div class="down-inner"></div>
        </div>
        <div class="layer"></div>
        <div class="layer2"></div>
    </div>
</template>

<script>
export default {
    name: 'HomeBg',
    props: ['scrollTopNum'],
    data(){
        return {
            windowHeight: 'auto',
            inited: false
        }
    },
    computed: {
        values(){
            const {windowHeight, scrollTopNum} = this;
            return [windowHeight == 'auto' ? 0 : parseInt(windowHeight), scrollTopNum];
        },

        /**滚动时样式 */
        styles(){
            const {values} = this;
            let windowHeight = values[0];
            let scrollTopNum = values[1];
            
            if(!windowHeight){
                return {};
            }
            windowHeight -= windowHeight * 0.26; //确保比如视频高度为 1000 ， 在 滚动到 1000 - 260 = 740 时，底部变黑

            let maxTranslateY = windowHeight * 0.2; //滚动时，文字向下偏移
            let multi = scrollTopNum / windowHeight;

            multi = multi > 1 ? 1 : multi;
            return {
                opacity: 1 - multi,
                filter: `grayscale(${multi*100}%)`,
                transform: `translate(0px, ${maxTranslateY*multi}px)`
            }
        },
    },
    watch: {
        values(array){
            if(!this.inited && window.scrollY < array[0]){
                setTimeout( ()=> {
                    this.inited = true;
                }, 500)
            }
        }
    },
    mounted(){
        this.$nextTick(()=>{
            this.inited = window.scrollY < this.values[0];
        })
    },
    created(){
        this.setWidthHeight();
        window.addEventListener('resize', this.setWidthHeight);
    },
    destroyed(){
        window.removeEventListener("resize", this.setWidthHeight);
    },
    methods: {
        /**设置高度 */
        setWidthHeight(){
            this.windowHeight = $(window).height() + 'px';
        },

        /**滚动至下一屏幕 */
        nextPage(){
            this.scrTo(parseInt(this.windowHeight));
        }
    },
}
</script>

<style lang="less">
    
    @keyframes hidebg {
        0% {opacity: 1;}
        100% {opacity: 0;visibility: hidden;}
    }
    @keyframes downSale {
        0%, 20%, 80%, 100% {opacity: 1;transform: perspective(600px) translate3d(0px, 0px, 0px) scale(1);}
        30% {opacity: 0.8;transform: perspective(600px) translate3d(0px, 0px, 0px) scale(0.9);}
        35% {opacity: 0.7;transform: perspective(600px) translate3d(0px, 0px, 0px) scale(0.8);}

        40%, 60% {opacity: 0.5;transform: perspective(600px) translate3d(0px, 0px, 0px) scale(0.7);}
        
        70% {opacity: 0.7;transform: perspective(600px) translate3d(0px, 0px, 0px) scale(0.8);}
        75% {opacity: 0.8;transform: perspective(600px) translate3d(0px, 0px, 0px) scale(0.9);}
    }
    @keyframes downFadeInUp {
        0% {opacity: 0;-webkit-transform: translateY(78px);-ms-transform: translateY(78px);transform: translateY(78px);filter: grayscale(100%);}
        100% {opacity: 1;-webkit-transform: translateY(0);-ms-transform: translateY(0);transform: translateY(0);filter: grayscale(0);}
    }

    .animated() {
        animation-duration: 1s;
        animation-fill-mode: both
    }

    .home-bg{
        &{position: relative;display: flex;background: rgb(45, 48, 50);overflow: hidden;}
        .video, .layer, .layer2, .down{width: 100%;height: 100%;position: absolute;left: 0;right: 0;top: 0;bottom: 0;}
        .video{width: 100%;height: 100%;object-fit: cover;background-size: cover;opacity: 1;transform: translate(0px, 0px)!important;}
        .layer{background-color: rgba(45, 48, 50, 0.25);z-index: 5;}
        .layer2{background-color: #2d3032;z-index: 6;}
        .text{margin: auto;position: relative;z-index: 7;text-align: center;display: none;font-family: Poppins;}
        .text1{font-weight: bold;font-size: 90px;line-height: 90px;color: #fff;margin-bottom: 40px;}
        .text2{font-size: 25px;line-height: 30px;color: rgba(255, 255, 255, 0.65);}
        .down{
            &{width: 78px;height: 78px;z-index: 8;bottom: 78px;top: auto;left: 50%;margin-left: -39px;cursor: pointer;transform: translateY(200px);}
            .down-inner{
                &{width: 100%;height: 100%;border: 2px solid;border-color: rgba(255, 255, 255, 0.65);border-radius: 40px;}
                &::before{content: '';border-style: solid;border-color: rgba(255, 255, 255, 0.65);border-width: 0 5px 5px 0;width: 20px;height: 20px;display: block;transform: rotate(45deg);margin: 18px auto 0;}
                &:hover{
                    &{background: #e05616;border-color:#fff;}
                    &::before{border-color:#fff;}
                }
            }
        }

        &.inited{
            .layer2{animation-name: hidebg;animation-delay: .3s;.animated();}
            .text{display: block;}
            .text1{animation-name: fadeInUp;.animated();}
            .text2{animation-name: fadeInUp;animation-delay: .2s;.animated();}
            .down{
                &{animation-name: downFadeInUp;.animated();animation-delay: .6s;}
                .down-inner{animation-name: downSale;animation-iteration-count: infinite;animation-duration: 2s;animation-fill-mode: both;}
            }
        }
        @media (max-width: 1023px){
            .text1{font-size: 80px;line-height: 80px;}
            .down{
                &{width: 50px;height: 50px;margin-left: -25px;}
                .down-inner:before{border-width: 0 3px 3px 0;width: 12px;height: 12px;margin-top: 14px;}
            }
        }
        @media (max-width: 777px){
            .text1{font-size: 70px;line-height: 70px;}
            .text2{font-size: 20px;line-height: 25px;}
        }
        @media (max-width: 479px){
            .text1{font-size: 50px;line-height: 50px;}
            .text2{font-size: 17px;}
        }
    }
</style>